<section class="container">
    <div class="auto-po-modal-container m-4"> 
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <section>
                <form class="row g-3" [formGroup]="createPOForm">
                    <div class="col-md-6">
                        <label for="sales_order" class="form-label text-small">Sales Order</label>
                        <input type="text" class="form-control form-control" id="sales_order" formControlName="sales_order" [error]="createPOForm.get('sales_order')">
                        <form-feedback [formGroup]="createPOForm" field="sales_order"></form-feedback>
                    </div>
                    <div class="col-md-6">
                        <label for="sales_item_no" class="form-label text-small">Sales Item Order</label>
                        <input type="text" class="form-control form-control" id="sales_item_no" formControlName="sales_item_no" [error]="createPOForm.get('sales_item_no')">
                        <form-feedback [formGroup]="createPOForm" field="sales_item_no"></form-feedback>
                    </div>
                    <div class="col-md-6">
                        <label for="service_line_item_no" class="form-label text-small">Sales Line Item No</label>
                        <input type="text" class="form-control form-control" id="service_line_item_no" formControlName="service_line_item_no" [error]="createPOForm.get('service_line_item_no')">
                        <form-feedback [formGroup]="createPOForm" field="service_line_item_no"></form-feedback>
                    </div>
                    <div class="col-md-6">
                        <label for="tax_code" class="form-label text-small">Tax Code</label>
                        <select formControlName="tax_code" class="form-control form-control-sm" [error]="createPOForm.get('tax_code')">
                            <option [ngValue]="null" selected disabled>Select User</option>
                            <option *ngFor="let taxcode of taxCodeList" [value]="taxcode">{{ taxcode }}</option>
                        </select>
                        <form-feedback [formGroup]="createPOForm" field="tax_code"></form-feedback>
                    </div>
                </form>
            </section>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</button>
        <button class="btn btn-primary text-white mx-2" (click)="createPO()" [disabled]="!createPOForm.valid">Create PO</button>
    </div>
    </div>
</section>